import React, { useEffect, useRef, useState, FC } from "react";
import { Button } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { usePurchaseRoDetailsModel } from "../scmPurchaseRoModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { ISCMPurchaseRoFormFields } from "../scmPurchaseRoType";
import useGlobalModel from "@/model/globalModel";


export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>();
    const {
        lookFormVal,
        getPRoDetailOne,
        resetLookCatch,
    } = usePurchaseRoDetailsModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        getPRoDetailOne(id)
    }, []);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            resetLookCatch()
        }
    }, [selectedNavId])

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退货单号",
                fieldName: "returnCode",
                disable: true,
                placeholder: "自动生成"
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: '供应商',
                fieldName: "supplierName",
                placeholder: "供应商",
                rules: [{ required: true, message: "请选择供应商" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单下浮",
                fieldName: "discountRate",
                rules: [{ required: true, message: "该项为必填" }, { pattern: /^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/, message: '请输入0-1' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "应收金额",//"应付金额",//"开单金额",
                fieldName: "totalAmount",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "采购单位",
                fieldName: "bentityName",
                rules: [{ required: true, message: "请选择采购单位" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出库金额",
                fieldName: "stockIoTotalAmount",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "已收金额",
                fieldName: "receivedAmount",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单优惠",
                fieldName: "favorableAmount",
                rules: [{ pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠总额",
                fieldName: "discountTotalAmount",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退货地址",
                fieldName: "returnAddress",
                span: 12,
                labelCol: { span: 3 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退货原因",
                fieldName: "returnReason",
                span: 12,
                labelCol: { span: 3 },
                rules: [{ required: true, message: "请输入退货原因" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "退货时间",
                fieldName: "returnTime",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管",
                fieldName: "storekeeper",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 10,
                labelCol: { span: 4 },
                colClassName: "detail-note-col"
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "",
                span: 2,
                labelCol: { span: 16, offset: 8 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务",
                fieldName: "casher",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算员",
                fieldName: "reckoner",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "业务员",
                fieldName: "operator",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出库日期",
                fieldName: "stockIoTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算日期",
                fieldName: "settleTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结款日期",
                fieldName: "payTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "从属门店",
                fieldName: "shopName",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人",
                fieldName: "createUser",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单日期",
                fieldName: "createTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改日期",
                fieldName: "updateTime",
                hidden: more
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型名称",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购单位名称",
                fieldName: "bentityName",
                hidden: true
            },
        ]
    };

    const poFromConfig: IYhFormBox<ISCMPurchaseRoFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: lookFormVal,
        // onChange,
        disabled: true,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}